export default __webpack_public_path__ + "static/media/roundabout-right.d2d4dcda.svg";